const loggedIn = (token) => {
  localStorage.setItem("token", token);
}

export default loggedIn;